// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../index'
import Header, { HEADER_TYPE_SUBPAGE } from '../header/Header'
import Container from '../../common/container/Container'
import Page from '../../common/page/Page'
import css from './noGroupPage.css'

const guideURL = 'https://sryhma.service-now.com/sp?id=sc_cat_item&sys_id=203420031b7a40108df063d76e4bcb73'

function NoGroupPage() {
  return (
    <Page>
      <Header title={i18n.t('noGroup.header')} showNav={false} showLogo={false} headerType={HEADER_TYPE_SUBPAGE} />
      <Container>
        <div className={css.text}>
          <p>Hei,</p>
          <p>{i18n.t('noGroup.title')}</p>
          <p>
            <a href={guideURL}>{guideURL}</a>
          </p>
        </div>
      </Container>
    </Page>
  )
}

export default NoGroupPage
